import Phaser from 'phaser';
import { loadAll } from '../systems/ContentLoader';
import { store } from '../state/store';

export class BootScene extends Phaser.Scene {
  constructor() {
    super({ key: 'Boot' });
  }

  async create(): Promise<void> {
    try {
      const { content, manifest } = await loadAll();
      store.init(content, manifest);
      this.scene.start('Preload');
    } catch (err) {
      console.error('Boot failed:', err);
      this.add
        .text(
          this.scale.width / 2,
          this.scale.height / 2,
          `Boot failed:\n${(err as Error).message}\n\nCheck the console for details.`,
          { fontFamily: 'monospace', fontSize: '20px', color: '#ffaaaa', align: 'center' },
        )
        .setOrigin(0.5);
    }
  }
}
